import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LayersIcon(props: IconProps) {
    return <Icon {...props} iconKey={"layers"}/>
}
